import { render, staticRenderFns } from "./AllEvents.vue?vue&type=template&id=db87d426&scoped=true&"
import script from "./AllEvents.vue?vue&type=script&lang=js&"
export * from "./AllEvents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db87d426",
  null
  
)

export default component.exports